import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommuteDeliveryVan = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.572 14.055L25.019 10.226C24.089 8.832 22.534 8 20.859 8H17.828C17.415 6.836 16.304 6 15 6H5C3.346 6 2 7.346 2 9V21C2 22.654 3.346 24 5 24H6.538C7.231 25.194 8.523 26 10 26C11.477 26 12.769 25.194 13.462 24H18.538C19.231 25.194 20.523 26 22 26C23.477 26 24.769 25.194 25.462 24H27C28.654 24 30 22.654 30 21V17C30 15.541 28.953 14.323 27.572 14.055ZM23.355 11.336L25.131 14H18V10H20.859C21.864 10 22.798 10.499 23.355 11.336ZM10 24C8.897 24 8 23.103 8 22C8 20.897 8.897 20 10 20C11.103 20 12 20.897 12 22C12 23.103 11.103 24 10 24ZM22 24C20.897 24 20 23.103 20 22C20 20.897 20.897 20 22 20C23.103 20 24 20.897 24 22C24 23.103 23.103 24 22 24ZM28 21C28 21.551 27.551 22 27 22H26C26 19.794 24.206 18 22 18C19.794 18 18 19.794 18 22H14C14 19.794 12.206 18 10 18C7.794 18 6 19.794 6 22H5C4.449 22 4 21.551 4 21V9C4 8.449 4.449 8 5 8H15C15.551 8 16 8.449 16 9V17C16 17.552 16.448 18 17 18C17.552 18 18 17.552 18 17V16H27C27.551 16 28 16.449 28 17V21Z" />
	</svg>
);

export default CommuteDeliveryVan;
